import * as React from 'react';

import { EvaluationPanelProvider } from './evaluation-panel-context';
import { evaluationPanelPaths } from '../models/path-model';
import { useIsModuleRoute } from '../../main/helpers/module-route';

export const EvaluationPanelConditionalProvider: React.FC = ({ children }) => {
  const { isModuleRoute } = useIsModuleRoute();

  if (!isModuleRoute(evaluationPanelPaths)) {
    return <>{children}</>;
  }

  return <EvaluationPanelProvider>{children}</EvaluationPanelProvider>;
};
